/*
 * @Date: 2022-08-29 09:18:33
 * @LastEditors: kinfai
 * @Description: 聊天会话
 * @LastEditTime: 2022-09-19 09:34:32
 * @FilePath: \my-app\src\pages\ChatConversation\index.jsx
 */
import {useContext, useEffect, useLayoutEffect, useState, useRef} from "react";
import {RouteContext} from "@/provide/route-context.js";
import useTurms from "../../hooks/turms/index.js";
import useTaskMsg from "../../hooks/taskMessage/index.js";
import useCs from "../../hooks/cs/index.js";
import useMessageManange from "../../hooks/messageManange/index.js";
import useLevelMsgTask from "../../hooks/levelMsgTask/index.js";


// components
import UserInfo from "./components/UserInfo";
import ChatContent from "./components/ChatContent";
import ContentEditor from "./components/ContentEditor";

export default function ChatConversation() {
    const context = useContext(RouteContext)
    const {sendMessageToCs, getTurms} = useTurms()
    const {getCsId, getKefu, editCsid} = useCs()
    const {emitQuestion} = useTaskMsg()
    const turms = getTurms()
    const {formatMsg: formatMsgFn} = useMessageManange()
    const {setup, initSpeed} = useLevelMsgTask()

    // 滚动消息列表
    const scrollToBottom = (height, speed = 750) => {
        setTimeout(() => {
            ChatContentRef.current.scrollToBottom(height)
        }, speed)
    }

    // 消息列表
    const [msgList, setMsgList] = useState([])
    const ChatContentRef = useRef()
    const [pageInfo, setPageInfo] = useState({
        page: 0,
        size: 20,
        canLoading: true
    })
    const updatePageInfo = (pageInfo, data) => {
        const canLoading = data && data.length && data.length === pageInfo.size

        const newPageInfo = {
            ...pageInfo,
            page: pageInfo.page + 1,
            canLoading
        }

        setPageInfo(() => newPageInfo)
        return newPageInfo
    }
    const queryMessage = async () => {
        const csId = await getCsId()
        const res = await turms.messageService.queryMessages({
            fromIds: [csId],
            areGroupMessages: false,
            hasSelfMessages: true,
            ...pageInfo
        })
        if (res.code === 1000) {
            updatePageInfo(pageInfo, res.data)

            // console.log("消息列表", res.data)
            const chatList = res.data
            for (let msg of chatList) {
                const uniqueTarget = msgList.find(item => item.id === msg.id)
                if (!uniqueTarget) {
                    msg = await formatMsgFn(msg)
                    setMsgList(value => [msg, ...value])
                }
            }
            // console.log("消息最终形态", msgList)
            return msgList
        }
        return []
    }
    const loadQueryMessage = async () => {
        const list = await queryMessage()
        const height = list.length ? 50 : 0
        scrollToBottom(height)
    }

    // 发送文本消息
    const addTextMsg = async (text) => {
        const value = String(text).trim()
        if (value === "") {
            return false
        }

        const csId = await getCsId()
        let {code, data: id} = await sendMessageToCs(csId, value)
        if (code === 1000) {
            const msg = {
                id,
                isMe: true,
                isRead: false,
                type: "text",
                value
            }
            setMsgList(value => [...value, msg])
            scrollToBottom()
        }
    }

    // 本地用户发送消息
    const addMsg = async (msg) => {
        msg.value = String(msg.value).trim()
        if (msg.value === '') {
            return false
        }

        const csId = await getCsId()
        console.log("发送客服id", csId)
        let res = await sendMessageToCs(csId, msg.value)
        if (res.code === 1000) {
            console.log("发送成功~")
            msg.id = res.data
        } else {
            console.log("发送失败")
        }
        setMsgList(value => [...value, msg])
        scrollToBottom()
    }

    // 等待
    // const awaiter = () => new Promise(resolve => setTimeout(() => resolve(), 1000))

    // 判断是否是第一次对话
    let isFirst = true
    useEffect(() => {
        const main = async () => {
            turms.messageService.addMessageListener(async msg => {
                msg = await formatMsgFn(msg)
                if (!msg.isMe) {
                    initSpeed(180)
                }

                setMsgList(value => [...value, msg])
            })

            turms.notificationService.addNotificationListener(async msg => {
                try {
                    const text = JSON.parse(msg.relayedRequest.createNeedkeNotifyRequest.text)
                    const kfId = text.kfId
                    console.log("委派id", kfId)
                    editCsid(kfId)
                    const kf = await getKefu(true)
                    console.log("新客服", kf)
                    //     添加一条委派msg
                    setMsgList(value => [...value, {
                        id: "kfc",
                        type: "transfer",
                        name: kf.name
                    }])

                } catch (e) {
                    console.log("通知消息-error", e)
                }
            })

            // 提问 - 若无提问则提问
            const csId = await getCsId()
            turms.messageService.queryMessages({
                fromIds: [csId],
                areGroupMessages: false,
                size: 10000,
                hasSelfMessages: true,
                messageType: 6
            }).then(res => {
                if (res.code === 1000 || res.code === 1001) {
                    // 提问
                    const result = res.data.find(msg => {
                        const text = JSON.parse(msg.text)
                        return text.type === 1
                    })
                    !result && emitQuestion()

                    //    是否存在 - 留言短信
                    const levelMsgResult = res.data.find(msg => {
                        const text = JSON.parse(msg.text)
                        return text.type === 3
                    })
                    !levelMsgResult && setup(180)
                }
            })
        }

        isFirst && main()

        return () => {
            isFirst = false
        }
    }, [])

    // 标记首次加载 - 查询聊天记录
    let isInit = false
    useEffect(() => {
        if (!isInit) {
            queryMessage()
            scrollToBottom()
        }
        return () => {
            isInit = true
        }
    }, [])

    // 通知返回面板 - 最后联系人
    const emitContinueChat = async (msg) => {
        const kfDetail = await getKefu()
        if (msg) {
            const userName = msg.isMe ? '您:' : kfDetail.name
            context.updateLastMsgInfo({
                ...msg,
                userName,
                avatar: msg.isMe ? "" : kfDetail.avatar
            })
        }
    }

    useLayoutEffect(() => {
        emitContinueChat(msgList[msgList.length - 1])
    }, [msgList])

    return <div style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        position: "absolute",
        zIndex: 1000,
        // width: "350px",
        width: '100%',
        visibility: context.csInfo.show ? '' : 'hidden'
    }}>
        <UserInfo setShow={context.updateCsInfo}/>
        <ChatContent
            msgList={msgList}
            ref={ChatContentRef}
            canLoading={pageInfo.canLoading}
            updatePageInfo={updatePageInfo}
            queryMessage={loadQueryMessage}
            addTextMsg={addTextMsg}
        />
        <ContentEditor addMsg={addTextMsg}/>
    </div>
}
